import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

// components
import {
    PdpSharedDescriptionAdditionalOptionsContent,
    Title,
} from './PdpSharedDescriptionAdditionalOptionsContent';
import {
    useItemTranslations,
    INTERFACE_STATE,
} from '../PdpSharedOriginalLanguageProvider/PdpSharedOriginalLanguageProvider';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import classNames from 'classnames';
import { getAttributeInfo } from '../helpers/getAttributeInfo';

function PdpSharedDescriptionAdditionalOptionsComponent(props) {
    const {
        headerClass,
        contentClass,
        wrapperClass,
        item,
        user,
        buttonType,
        collapsedHeight,
        showDyoVersion,
    } = props;
    const [state] = useItemTranslations();
    const itemAttributes =
        state?.interfaceState === INTERFACE_STATE.SHOW_ORIGINAL
            ? state?.data?.viewer?.item?.attributes
            : item?.attributes;
    const { isCustomizable, isDyoCustomizable, isJewelry } = item;
    const { customizationOptions, isResizable } = getAttributeInfo(itemAttributes);

    if ((!isCustomizable || !customizationOptions) && !isResizable && !isDyoCustomizable) {
        return null;
    }

    if (isDyoCustomizable && !showDyoVersion) {
        return null;
    }

    return (
        <div
            data-tn="pdp-item-description-customization-options"
            className={classNames(styles.wrapper, wrapperClass)}
        >
            <h2 className={classNames(styles.header, headerClass)}>
                <Title isDyoCustomizable={isDyoCustomizable} isJewelry={isJewelry} />
            </h2>
            <PdpSharedDescriptionAdditionalOptionsContent
                customizationOptions={customizationOptions}
                contentClass={contentClass}
                collapsedHeight={collapsedHeight}
                buttonType={buttonType}
                isDyoCustomizable={isDyoCustomizable}
                isResizable={isResizable}
                item={item}
                user={user}
            />
        </div>
    );
}

PdpSharedDescriptionAdditionalOptionsComponent.propTypes = {
    wrapperClass: PropTypes.string,
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    collapsedHeight: PropTypes.number,
    buttonType: PropTypes.string,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    showDyoVersion: PropTypes.bool,
};

export const PdpSharedDescriptionAdditionalOptions = createFragmentContainer(
    PdpSharedDescriptionAdditionalOptionsComponent,
    {
        user: graphql`
            fragment PdpSharedDescriptionAdditionalOptions_user on User {
                ...PdpSharedDescriptionAdditionalOptionsContent_user
            }
        `,
        item: graphql`
            fragment PdpSharedDescriptionAdditionalOptions_item on Item {
                ...PdpSharedDescriptionAdditionalOptionsContent_item
                isJewelry
                isCustomizable
                isDyoCustomizable
                attributes {
                    customizable {
                        option {
                            serviceId
                        }
                        text
                    }
                    ringResizable {
                        option {
                            serviceId
                        }
                    }
                }
            }
        `,
    }
);
